import { createContext } from "react";

export const MultilevelAccordionContext = createContext<{
  maxIndent: number;
}>({
  maxIndent: 3,
});
